import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../../structure/row';
import { Cell, CENTER } from '../../structure/cell';
import { generateClassName } from '../../../../../_modules/helper/generate_class_name';
import Translation from '../../../translation/translation';
import { show } from '../../../../actions/clearance_info_light_box_actions';
import { Price } from '../price';
import onCrossSellDetailsClick from '../../actions/on_cross_sell_details_click';
import { getCsrfTokenQueryParam, isCsrfTokenExists } from '../../../../../utilities/csrf_token_provider';

const lazyClassNames = generateClassName({
  'sidebar-product-type-row': true,
  'sidebar-product-type-row--no-details': ({ showDetails }) => showDetails,
});

export function TypeRow(props) {
  const {
    label,
    quantity,
    clearance,
    onRemoveCrossSellClick,
    cartProductType,
    type,
    pricePerItem,
    currencyIsoCode,
    hasPaddingBottom,
    showDetails,
    lightContentAvailable,
    productId,
  } = props;
  const labelContent = (
    <>
      <span
        className={`sidebar__tag sidebar__tag--black ${
          isCrossSellProduct(cartProductType, lightContentAvailable) ? 'cursor-pointer' : ''
        }`}
        onClick={(e) =>
          isCrossSellProduct(cartProductType, lightContentAvailable) &&
          onCrossSellDetailsClick({ spinachId: productId })
        }
      >
        {label}
      </span>

      {!isOnlyCrossSellProduct(cartProductType) && (
        <Translation
          translationKey={quantity > 1 ? 'sidebar-set-amount' : 'sidebar-set-amount-single-item'}
          placeholder={{ quantity }}
          className="sidebar__tag"
        />
      )}

      {clearance && (
        <Translation
          translationKey="clearance-badge-text"
          className="sale-price__tag sale-price__tag--clearance open-clearance-lightbox cursor-pointer"
          onClick={show}
        />
      )}

      {isOnlyCrossSellProduct(cartProductType) && type !== 'tyre_stewardship' && (
        <span style={{ marginLeft: '10px', cursor: 'pointer', verticalAlign: 'middle' }}>
          <svg
            onClick={(e) => onRemoveCrossSellClick(e, { spinachId: props.productId, removeFromCart: true })}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-trash"
            viewBox="0 0 16 16"
          >
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
            <path
              fillRule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
            />
          </svg>
        </span>
      )}

      {!isOnlyCrossSellProduct(cartProductType) && type !== 'tyre_stewardship' && (
        <span style={{ marginLeft: '10px', cursor: 'pointer', verticalAlign: 'middle' }}>
          <a
            class="item__delete"
            href={`${TYROOLA.globals.urlPrefix}/cart/remove/?id=${props.productId}${isCsrfTokenExists() ? `&${getCsrfTokenQueryParam()}` : ''}`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-trash"
              viewBox="0 0 16 16"
            >
              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
              <path
                fillRule="evenodd"
                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
              />
            </svg>
          </a>
        </span>
      )}
    </>
  );

  return (
    <Row className={lazyClassNames(props)} hasPaddingBottom={false}>
      <Cell side={CENTER} colSpan={3}>
        {showDetails ? (
          labelContent
        ) : (
          <table>
            <tbody>
              <Price
                name={'price-type-row-' + label}
                label={labelContent}
                price={quantity * pricePerItem}
                currencyIsoCode={currencyIsoCode}
                hasBorder={false}
                hasPaddingBottom={hasPaddingBottom}
              />
            </tbody>
          </table>
        )}
      </Cell>
    </Row>
  );
}

TypeRow.propTypes = {
  label: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  showDetails: PropTypes.bool,
  clearance: PropTypes.bool.isRequired,
};

TypeRow.defaultProps = {
  showDetails: true,
};

const isOnlyCrossSellProduct = (cartProductType) => cartProductType === 'cross_sell_product';

const isCrossSellProduct = (cartProductType, lightContentAvailable) => !!lightContentAvailable;
